import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { Column, ConfirmationModal, Typography } from 'seagull';
import { ContactRolePicker } from '~/components/ContactRolePicker/ContactRolePicker';
import { useLocaleKeys } from '~/i18n';
import { GetChangeContactRoleModalTID, ROLE_FIELD_NAME, assignableRoleOf, changeContactRoleModalTextsPath } from './ChangeContactRoleModal.utils';
import { useChangeContactRole } from './hooks/useChangeContactRole';
export const ChangeContactRoleModal = (param)=>{
    let { contact, dismissModal, testId } = param;
    const { t } = useLocaleKeys(changeContactRoleModalTextsPath);
    const { ChangeContactRoleModalTestIds } = useMemo(()=>GetChangeContactRoleModalTID(testId), [
        testId
    ]);
    const { errorMessage, changeRole } = useChangeContactRole({
        contact,
        dismissModal,
        successToastTestId: ChangeContactRoleModalTestIds.SuccessToast()
    });
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            [ROLE_FIELD_NAME]: assignableRoleOf(contact)
        }
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        openBottomSheetOnMobile: true,
        title: t.title(),
        primaryButtonLabel: t.saveButton(),
        secondaryButtonLabel: t.cancelButton(),
        testId: ChangeContactRoleModalTestIds.Root(),
        textAlignCenter: false,
        primaryButtonTestId: ChangeContactRoleModalTestIds.SaveButton(),
        secondaryButtonTestId: ChangeContactRoleModalTestIds.CancelButton(),
        bi: {
            primaryButton: {
                name: 'client_detail_change_role_submit'
            },
            secondaryButton: {
                name: 'client_detail_change_role_cancel'
            },
            closeButton: {
                name: 'client_detail_change_role_close'
            }
        },
        onPrimaryButtonClick: handleSubmit(changeRole),
        onSecondaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: 24,
            children: [
                /*#__PURE__*/ _jsx(ContactRolePicker, {
                    control: control,
                    name: ROLE_FIELD_NAME,
                    testId: ChangeContactRoleModalTestIds.RolePicker()
                }),
                errorMessage != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    skin: "error",
                    testId: ChangeContactRoleModalTestIds.SaveError(),
                    children: errorMessage
                })
            ]
        })
    });
};
